import { Duration as LuxonDuration } from 'luxon';
export var sortLocations = function (a, b) {
    var alocationName = "".concat(a.site.lineOfBusiness, " - ").concat(a.site.id);
    var blocationName = "".concat(b.site.lineOfBusiness, " - ").concat(b.site.id);
    return alocationName.localeCompare(blocationName);
};
export function useLocationEligibilityList(_a) {
    var _b, _c;
    var siteEligibilities = _a.siteEligibilities;
    var availableLocations = (_b = siteEligibilities === null || siteEligibilities === void 0 ? void 0 : siteEligibilities.filter(function (item) {
        return LuxonDuration.fromISO(item.eligibleDuration.value).as('minutes') > 0;
    })) !== null && _b !== void 0 ? _b : [].sort(sortLocations);
    var unavailableLocations = (_c = siteEligibilities === null || siteEligibilities === void 0 ? void 0 : siteEligibilities.filter(function (item) {
        return LuxonDuration.fromISO(item.eligibleDuration.value).as('minutes') <= 0;
    })) !== null && _c !== void 0 ? _c : [].sort(sortLocations);
    return {
        availableLocations: availableLocations,
        unavailableLocations: unavailableLocations
    };
}
